<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>photo_library</mat-icon>
      Images
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-table [dataSource]="DataSource">
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef> Title</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.title}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef> Image</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <img
            [src]="getImageUrl(row, true)"
            [title]="row.title"
            alt="{{row.title}}"
            />
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="actions">
          <button (click)="addImage()" mat-icon-button matTooltip="Add image.">
            <mat-icon>add</mat-icon>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="actions">
          @if (!row.featured) {
            <button
              (click)="deleteItem(row)"
              mat-icon-button
              matTooltip="Remove image."
              >
              <mat-icon>delete</mat-icon>
            </button>
          }
          <button
            (click)="setFeatured(row)"
            [disabled]="row.featured"
            mat-icon-button
            matTooltip="Set featured image."
            >
            <mat-icon
              >{{row.featured && 'radio_button_checked' ||
              'radio_button_unchecked'}}</mat-icon
              >
            </button>
            <a
              [href]="getImageUrl(row)"
              mat-icon-button
              matTooltip="View image."
              target="_blank"
              >
              <mat-icon>visibility</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{featured: row.featured}"
        ></mat-row>
      </mat-table>
    </section>
  </section>
